import { Dialog, DialogContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { reactIcons } from "../../../utils/icons";

const STORAGE_KEY = "bridgeKeyNoticeSeenAt";
const SHOW_EVERY_MS = 6 * 60 * 60 * 1000;

const isDue = () => {
  try {
    const seenAt = Number(localStorage.getItem(STORAGE_KEY));
    return !seenAt || Date.now() - seenAt >= SHOW_EVERY_MS;
  } catch {
    return true;
  }
};

const BridgeKeyNoticeModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isDue()) setOpen(true);
    const id = setInterval(() => {
      if (isDue()) setOpen(true);
    }, 60 * 1000);
    return () => clearInterval(id);
  }, []);

  const handleClose = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {}
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="false"
      aria-labelledby="bridgekey-notice-title"
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "550px",
        },
        zIndex: 10001,
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0,0,0,0.7)",
          backdropFilter: "blur(4px)",
        },
        "& .MuiPaper-root": {
          background:
            "linear-gradient(292deg, #730000 0%, #000000 75%, #000000 100%)",
          border: "1px solid #730000",
          borderRadius: "18px",
          boxShadow: "0 24px 60px -20px rgba(238,0,0,0.45)",
        },
      }}
    >
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <div className="relative text-white">
          <button
            type="button"
            aria-label="Close"
            onClick={handleClose}
            className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-lg border border-white/15 bg-white/5 text-white/80 transition-colors hover:border-[#EE0000] hover:bg-[#EE0000] hover:text-white"
          >
            {reactIcons.close}
          </button>

          <span className="inline-flex items-center gap-2 rounded-full border border-[#EE0000]/50 bg-[#EE0000]/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-[#ff6b6b]">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#EE0000]" />
            Announcement
          </span>

          <h2
            id="bridgekey-notice-title"
            className="mt-4 pr-8 text-[22px] font-bold leading-tight sm:text-[24px]"
          >
            BridgeKey Lite is launching soon!
          </h2>

          <p className="mt-3 text-14 leading-relaxed text-white/75">
            The new BridgeKey Lite version will require you to import your Seed
            Phrase to access your wallet.
          </p>

          <p className="mt-4 rounded-xl border border-[#EE0000]/40 bg-[#EE0000]/10 px-4 py-3 text-14 font-bold leading-relaxed text-white">
            Please securely back up the Seed Phrase of your existing BridgeKey
            wallet now{" "}
            <span className="font-medium">
              to ensure uninterrupted access to your wallet in the future.
            </span>
          </p>

          <button
            type="button"
            onClick={handleClose}
            className="mt-6 h-11 w-full rounded-xl bg-gradient-to-r from-[#730000] to-[#9d0303] text-14 font-semibold text-white transition-all hover:from-[#8a0000] hover:to-[#EE0000]"
          >
            Got it
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BridgeKeyNoticeModal;
